import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client.js";
import { DataTable } from "@/components/DataTable.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";
import { localizeDemo } from "@/i18n/orignalI18n.js";

export function TripsPage() {
  const { ui, lang } = useOrignalUi();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/api/trips").then((d) => setItems(d.items)).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-trips">
      <h1>{ui.trips.title}</h1>
      <p className="og-lead">{ui.trips.subtitle}</p>
      <DataTable
        rows={items.map((t) => ({ ...t, name: localizeDemo(t.name, lang), statusLabel: ui.status[t.status] || t.status, dates: t.start_date || ui.today.datesPending }))}
        searchKeys={["name", "territory", "statusLabel"]}
        columns={[{ key: "name", label: ui.trips.title }, { key: "statusLabel", label: ui.status.preparation }, { key: "dates", label: ui.today.dates }]}
        filters={[{ key: "status", options: ["preparation", "confirmed", "in_progress", "done", "cancelled"].map((s) => ({ value: s, label: ui.status[s] })) }]}
        emptyLabel={ui.trips.empty}
        testId="trips-table"
      />
      <Link className="og-btn og-btn--primary" to="/sejour">{ui.today.openTrip}</Link>
    </main>
  );
}
